import { Box, Skeleton, Typography, pn } from '@compass/core';
import { Column } from 'devextreme-react/data-grid';
import { DevExpressReport } from 'components';
import { DashboardCard } from '../components/DashboardCard';
import { useStudentServiceData } from '../contexts';
import { StudentServiceDistributionDto } from 'generated/openApi';
import { StudentServiceFilterControls } from './StudentServiceFilterControls';

export const StudentServiceTableCard = () => {
    const { data, loading, error, metric } = useStudentServiceData();
    return <DashboardCard title="Annual Services"><Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <StudentServiceFilterControls />
        {loading ? <Skeleton variant="rounded" height={400} /> : error ? <Typography color="error" align="center">{error}</Typography> :
        <Box sx={{ flexGrow: 1, minHeight: 0 }}><DevExpressReport dataSource={data} fullPageSize showColumnChooser={false}>
            <Column dataField={pn<StudentServiceDistributionDto>('year')} caption="School Year" cellRender={({ value }) => `${value}-${value + 1}`} />
            <Column dataField={pn<StudentServiceDistributionDto>('studentServiceName')} caption="Service" />
            <Column dataField={pn<StudentServiceDistributionDto>('studentCount')} caption="Participants" />
            {metric === 'participantRate'
                ? <Column dataField={pn<StudentServiceDistributionDto>('participantRate')} caption="Participation Rate" cellRender={({ value }) => `${value}%`} />
                : <Column dataField={pn<StudentServiceDistributionDto>('averageHours')} caption="Average Hours" />}
            <Column dataField={pn<StudentServiceDistributionDto>('totalHours')} caption="Total Hours" />
        </DevExpressReport></Box>}
    </Box></DashboardCard>;
};
